(() => {
const key='calton_brown_wishlist';
const read=()=>{try{return JSON.parse(localStorage.getItem(key)||'[]')}catch{return[]}};
const write=v=>localStorage.setItem(key,JSON.stringify(v));
const sync=()=>{
 const items=read();
 document.querySelectorAll('[data-wishlist-count]').forEach(e=>{e.textContent=items.length;e.hidden=!items.length});
 document.querySelectorAll('[data-wishlist-add]').forEach(b=>b.classList.toggle('is-active',items.some(i=>String(i.id)===String(b.dataset.productId))));
 const box=document.querySelector('[data-wishlist-items]'); if(!box)return;
 if(!items.length){box.innerHTML='<p class="wishlist-popover__empty">Your wishlist is empty.</p>';return}
 box.innerHTML=items.map(i=>'<article class="wishlist-item"><a href="'+i.url+'" class="wishlist-item__link">'+(i.image?'<img src="'+i.image+'" alt="'+i.title.replace(/"/g,'&quot;')+'" loading="lazy">':'')+'<span class="wishlist-item__title">'+i.title+'</span></a><button type="button" class="button-unstyled wishlist-item__remove" data-wishlist-remove="'+i.id+'" aria-label="Remove '+i.title.replace(/"/g,'&quot;')+'">×</button></article>').join('');
 box.insertAdjacentHTML('beforeend','<div class="wishlist-popover__actions"><button type="button" class="button wishlist-buy-all" data-wishlist-buy-all>Buy all & checkout</button><p class="wishlist-buy-all__note">One available variant will be added for each saved item.</p><p class="wishlist-buy-all__status" data-wishlist-status aria-live="polite"></p></div>');
};
const setStatus=(message,error=false)=>{
 const el=document.querySelector('[data-wishlist-status]'); if(el){el.textContent=message;el.classList.toggle('is-error',error);}
};
const buyAll=async(button)=>{
 const items=read(); if(!items.length)return;
 button.disabled=true; button.setAttribute('aria-busy','true'); setStatus('Preparing your wishlist…');
 try{
   const products=await Promise.all(items.map(async item=>{
     const response=await fetch(item.url.replace(/\/$/,'')+'.js',{headers:{Accept:'application/json'}});
     if(!response.ok)throw new Error('product');
     const product=await response.json();
     const variant=product.variants?.find(v=>v.available) || null;
     return {item,variant};
   }));
   const unavailable=products.filter(x=>!x.variant);
   const addable=products.filter(x=>x.variant);
   if(!addable.length)throw new Error('None of the saved items are currently available.');
   const response=await fetch((window.Shopify?.routes?.cart_add_url)||'/cart/add.js',{
     method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
     body:JSON.stringify({items:addable.map(x=>({id:x.variant.id,quantity:1}))})
   });
   if(!response.ok)throw new Error('cart');
   if(unavailable.length){
     setStatus(unavailable.length+' saved item'+(unavailable.length===1?' is':'s are')+' currently unavailable. The available items are ready in your cart.');
     window.location.href='/cart';
     return;
   }
   window.location.href='/checkout';
 }catch(error){
   setStatus(error.message||'We could not prepare your wishlist. Please try again.',true);
   button.disabled=false; button.removeAttribute('aria-busy');
 }
};
document.addEventListener('click',e=>{
 const add=e.target.closest('[data-wishlist-add]'); if(add){e.preventDefault();e.stopPropagation();const id=String(add.dataset.productId),items=read(),n=items.findIndex(i=>String(i.id)===id);if(n>=0)items.splice(n,1);else items.push({id,title:add.dataset.productTitle,url:add.dataset.productUrl,image:add.dataset.productImage||''});write(items);sync();return}
 const rem=e.target.closest('[data-wishlist-remove]'); if(rem){write(read().filter(i=>String(i.id)!==String(rem.dataset.wishlistRemove)));sync();return}
 const buy=e.target.closest('[data-wishlist-buy-all]'); if(buy){e.preventDefault();buyAll(buy)}
});
document.addEventListener('DOMContentLoaded',sync);window.addEventListener('storage',sync);sync();
})();